export const validateAlphabetsOnly = (_, value) => {
  const regex = /^[a-zA-Z\s]*$/;
  if (!regex.test(value)) {
    return Promise.reject("Please enter alphabets only");
  }
  return Promise.resolve();
};

// Academic year runs June-May, matching the convention already used on the
// main admin dashboard (Iskool360Dashboard.js's getCurrentAcademicYear).
export const getAcademicYearForDate = (date) => {
  const d = new Date(date);
  if (isNaN(d.getTime())) return null;
  const year = d.getFullYear();
  const month = d.getMonth() + 1;
  const startYear = month >= 6 ? year : year - 1;
  const endYearShort = String(startYear + 1).slice(-2);
  return `${startYear}-${endYearShort}`;
};

// Formats a plain 4-digit year value (e.g. an application's enrollment_year)
// into the same "YYYY-YY" academic-year notation, for display consistency.
export const formatAcademicYearFromYear = (year) => {
  const y = parseInt(year, 10);
  if (!year || isNaN(y)) return null;
  return `${y}-${String(y + 1).slice(-2)}`;
};

// Raw start-year for "today" (e.g. 2026), for prefilling/generating options —
// use formatAcademicYearFromYear to render it in "YYYY-YY" form.
export const getCurrentAcademicStartYear = () => {
  const [startYear] = getAcademicYearForDate(new Date()).split("-");
  return parseInt(startYear, 10);
};

// Enrollment Year dropdown options: previous, current, and next two academic
// years, each { value: raw start-year string, label: "YYYY-YY" } so the
// field submits the same plain year the backend has always stored.
export const getEnrollmentYearOptions = () => {
  const currentStartYear = getCurrentAcademicStartYear();
  return [-1, 0, 1, 2].map((offset) => {
    const year = currentStartYear + offset;
    return { value: String(year), label: formatAcademicYearFromYear(year) };
  });
};
